import React from 'react'
import DragHandleOutlinedIcon from '@material-ui/icons/DragHandleOutlined'
import i18n from 'core/common/i18n'
import { Box } from 'core/components/Core'
import Typography from 'core/components/Typography'
import { useUpload } from '../../context'
import MessageError from './MessageError'

function ProductInfoDnD() {
  const [stateUpload] = useUpload()

  return (
    <>
      {stateUpload?.FILES.map(file => file?.error && <MessageError file={file} />)}
      <Box bgcolor="grey.300" display="flex" p={2} mt={3}>
        <DragHandleOutlinedIcon />
        <Typography pl={1} fontSize="small">
          {i18n.t('product.productUpload.infoDnd')}
        </Typography>
      </Box>
    </>
  )
}

export default ProductInfoDnD
